import React, { useEffect } from "react";
import { useBCMSContext, useStateManager, BCMSRecord, useModel, useRouteData, BCMSStateManagerCRUD } from "bcms-react";
import Classes, { ACHBatch, ACHFromAccount, ACHToParticipant } from "model";
import { PageContainer, PageContentView } from "components/shared";
import PendingSameDayACHBatchesWidget from "./components/PendingSameDayACHBatchesWidget ";
import PendingACHBatchesWidget from "./components/PendingACHBatchesWidget";
import ScheduledACHBatchesWidget from "./components/ScheduledACHBatchesWidget";
import HistoryACHWidget from "./components/HistoryACHWidget";
import ACHSearch from "./components/SearchOptionsFormView/classes/ACHSearch";

import "./styles.css";
import "./mobile.css";
import ACHBatchConfirmationWidget from "./components/ACHBatchConfirmationWidget";

/**
 * @function ActivityACHPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ActivityACHPage
 */
export default function ActivityACHPage(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);
  window.history.replaceState({}, document.title);
    // Branding options needed for captures
    const branding = useModel().branding.options;
    window.BRANDING = { 
        "ach_abi22" : branding.ach_abi22, 
        "users_abi22" : branding.users_abi22,
        "import_file_flyout_abi22": branding.import_file_flyout_abi22,
        "ach_import_abi22": branding.ach_import_abi22,
        "nonnacha_abi22": branding.nonnacha_abi22
    };

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,
      onACHConfirmationClose:()=>{
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "submittedOneTimeACHPayment" ], undefined)
        .submit(setState);
        window.history.replaceState({}, document.title);
      },
      showACHConfirmation:(data)=>{
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "submittedOneTimeACHPayment" ], data)
        .submit(setState);
      }
  });

  return (
    <PageContainer className="activity-ach-page" state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </PageContainer>
  )
}

export const getDefaultData = () => ({
  pendingSameDayACHBatchesWidgetData: {
    showSearchOptions: false,
    achBatches: ACHBatch.initAll().filter(item => item.status === "pending approval" && item.scheduleType === "same day")
    // Example of setting search values.
    //achSearch: ACHSearch.init({batch: "some batch 1", status: "rejected"})

  },
  pendingACHBatchesWidgetData: {
    showSearchOptions: false,
    achBatches: ACHBatch.initAll().filter(item => item.status === "pending approval" && item.scheduleType === "immediate")
    // Example of setting search values.
    //achSearch: ACHSearch.init({batch: "some batch 2", status: "approved"})
  },
  scheduledACHBatchesWidget: {
    showSearchOptions: false,
    achBatches: ACHBatch.initAll().filter(item => item.status === "pending approval" && item.scheduleType !== "same day")
    // Example of setting search values.
    //achSearch: ACHSearch.init({batch: "some batch 3", status: "approved", schedule: "some schedule"})
  },
  historyACHWidget: {
    showSearchOptions: false,
    viewLatestForRecurringBatches: true,
    achBatches: ACHBatch.initAll().filter(item => item.status === "canceled" )
    // Example of setting search values.
    //achSearch: ACHSearch.init({batch: "some batch 4", status: "approved"})
  },

  submittedOneTimeACHPayment: undefined
});

// no ui changes for now
export const getDefaultUI = () => ({
  pendingSameDayACHBatchesWidgetUI: {
    
  },
  pendingACHBatchesWidgetUI: {
    
  },
  scheduledACHBatchesWidgetUI: {
    
  },
  historyACHWidgetUI: {
    
  }
});

function PageContent(props) {
  const { data, ui, showACHConfirmation } = useStateManager();
  const { route } = useRouteData();
  const {addedOneTimeACHPayment} = route ? route : {}; 

  useEffect(()=>{
    if(addedOneTimeACHPayment!== undefined) {
      if(addedOneTimeACHPayment instanceof Object) {
        const achBatch = ACHBatch.initByID(addedOneTimeACHPayment.id);
        showACHConfirmation(achBatch)
      }
      
    }
  },[]);

  return (
  <PageContentView>
    <div className="flex-container flex-vertical flex-width">
       { data.submittedOneTimeACHPayment && <ACHBatchConfirmationWidget data={ data.submittedOneTimeACHPayment } /> }
        <PendingSameDayACHBatchesWidget data={ data.pendingSameDayACHBatchesWidgetData } ui={ ui.pendingSameDayACHBatchesWidgetUI } />
        <PendingACHBatchesWidget data={ data.pendingACHBatchesWidgetData } ui={ ui.pendingACHBatchesWidgetUI } />
        <ScheduledACHBatchesWidget data={ data.scheduledACHBatchesWidget } ui={ ui.scheduledACHBatchesWidgetUI } />
        <HistoryACHWidget data={ data.historyACHWidget } ui={ ui.historyACHWidgetUI } />
    </div>
  </PageContentView>
  );
}